import React from 'react';
import { Link } from 'react-router-dom';

const Tabs = () => {
    const tabs = [
        {
          name: "Dashboard",
          icon: "bi bi-microsoft",
          src: "#",
        },
        {
          name: "Faq's",
          icon: "bi bi-patch-question-fill",
          src: "#",
        },
        {
          name: "Shopping Feed",
          icon: "bi bi-reception-4",
          src: "#",
        },
        {
          name: "Help Center",
          icon: "bi bi-telephone-outbound-fill",
          src: "#",
        },
        {
          name: "Pricing",
          icon: "bi bi-currency-exchange",
          src: "#",
        },
      ];
    return (
        <div className="tabs-container">
          {tabs?.map((val, ind) => {
            return (
              <Link to={val?.src} key={ind}>
                <i className={val?.icon}></i>
                {val?.name}
              </Link>
            );
          })}
        </div>
    );
}

export default Tabs;
